import React from "react";
import Topbar from "./Components/Topbar";
import Navbar from "./Components/Navbar";
import Carousel from "./Home/Carousel"
import Service from "./Home/Service";
import About from "./Home/About";
import Fact from "./Home/Fact";
import Service2 from "./Home/Service2";
import Booking from "./Home/Booking";
import Team from "./Home/Team";
import Testimonial from "./Home/Testimonial";
import Footer from "./Home/Footer";
import { CartProvider } from "react-use-cart";

function App() {
  return (
    <CartProvider>
      <Topbar/>
      <Navbar/>
      <Carousel/>
      <Service/>
      <About/>
      <Fact/>
      <Service2/>
      <Booking/>
      <Team/>
      <Testimonial/>
      <Footer/>
    </CartProvider>
  );
}

export default App;
